export default class ValueFilter {
    /**
     * @param {string} field
     * @param {boolean|string|null} value
     */
    constructor(field, value) {

        this.field = field;
        this.value = value;
    }

     /**
     * Sets given `value` fo this filter.
     *
     * @param value
     * @returns {ValueFilter}
     */
    set(value) {
        this.value = value;
        return this;
    }
}
